import { apiClient } from '@/services/Axios';
import { toLegacyDetail, toLegacyPaginated, unwrapV1, v1Delete, v1Get, v1Post, v1Put } from '@/services/v1Api';

export const getCompanies = async (page = 1, perPage = 50) => {
    try {
        const { data, meta } = await v1Get('/api/v1/address-book/companies', {
            page,
            per_page: perPage,
        });
        return toLegacyPaginated(data, meta);
    } catch (error) {
        console.error('Error fetching companies:', error);
        throw error;
    }
};

export const getCompaniesByLetter = async (letter = null) => {
    try {
        const params = {};
        if (letter) params.letter = letter;
        const { data, meta } = await v1Get('/api/v1/address-book/companies', params);
        return toLegacyPaginated(data, meta);
    } catch (error) {
        console.error('Error fetching companies by letter:', error);
        throw error;
    }
};

export const fetchCompanyById = async (id) => {
    try {
        const { data } = await v1Get(`/api/v1/address-book/companies/${id}`);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error fetching company by ID:', error);
        throw error;
    }
};

export const createCompany = async (companyData) => {
    try {
        const { data } = await v1Post('/api/v1/address-book/companies', companyData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error creating company:', error);
        throw error;
    }
};

export const updateCompany = async (id, companyData) => {
    try {
        const { data } = await v1Put(`/api/v1/address-book/companies/${id}`, companyData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error updating company:', error);
        throw error;
    }
};

export const deleteCompany = async (id) => {
    try {
        await v1Delete(`/api/v1/address-book/companies/${id}`);
        return { success: true };
    } catch (error) {
        console.error('Error deleting company:', error);
        throw error;
    }
};

/** Get all address book company roles (for roles matrix). */
export const getCompanyRoles = async () => {
    try {
        const { data } = await v1Get('/api/v1/options/company-roles');
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Error fetching company roles:', error);
        throw error;
    }
};

// Upload company logo
export const uploadCompanyImage = async (companyId, imageFile) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);

        const response = await apiClient.post(
            `/api/v1/address-book/companies/${companyId}/upload-image`,
            formData
        );
        const { data } = unwrapV1(response);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error uploading company logo:', error);
        throw error;
    }
};

// Upload company document
export const uploadCompanyDocument = async (companyId, file, name, documentType = null) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', name);
        if (documentType) {
            formData.append('document_type', documentType);
        }

        const response = await apiClient.post(
            `/api/v1/address-book/companies/${companyId}/documents`,
            formData
        );
        const { data } = unwrapV1(response);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error uploading company document:', error);
        throw error;
    }
};

// Download document
export const downloadCompanyDocument = async (companyId, documentId) => {
    try {
        const response = await apiClient.get(
            `/api/v1/address-book/companies/${companyId}/documents/${documentId}/download`,
            {
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error downloading company document:', error);
        throw error;
    }
};

// Delete document
export const deleteCompanyDocument = async (companyId, documentId) => {
    try {
        await v1Delete(
            `/api/v1/address-book/companies/${companyId}/documents/${documentId}`
        );
        return { success: true };
    } catch (error) {
        console.error('Error deleting company document:', error);
        throw error;
    }
};
